import { render, staticRenderFns } from "./TdOrgInfo.vue?vue&type=template&id=3837aa26&"
import script from "./TdOrgInfo.vue?vue&type=script&lang=js&"
export * from "./TdOrgInfo.vue?vue&type=script&lang=js&"
import style0 from "./TdOrgInfo.vue?vue&type=style&index=0&id=3837aa26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports